import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const BillingDetailsWrapper = styled.div`
  .billing-details-title {
    padding: 24px 0;
    ${responsive.MOBILE`
      padding: 16px 0px 0px 0px;
    `}
  }

  .billing-details-select-applicable {
    margin: 16px 0;
  }

  .billing-details-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    ${responsive.MOBILE`
      grid-template-columns: 1fr;
    `}
  }

  .billing-details-early-pay {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    margin: 40px 0;

    ${responsive.MOBILE`
       margin: 16px 0;
       grid-template-columns: 1fr;
    `}
  }

  .billing-details-notes {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding-bottom: 24px;
    border-bottom: 1px dashed ${COLORS.primary_light_blue};
    ${responsive.MOBILE`
      grid-template-columns: 1fr;
      padding-bottom: 16px;
      width: 100%;
    `}
  }

  .notes-input {
    .MuiInputBase-root {
      height: 100px;
      background: ${COLORS.cirrus_black1};
      padding: 0px;
    }
  }
`;
